{
  "settings": "การตั้งค่า",
  "yourDigitalAssistant": "ผู้ช่วยอัตโนมัติของคุณ",
  "getStarted": "เริ่ม",
  "login": "เข้าสู่ระบบ",
  "loggingIn": "กำลังเข้าสู่ระบบ ...",
  "darkMode": "โหมดมืด",
  "clearHistory": "ล้างประวัติ",
  "historyCleared": "ล้างประวัติแล้ว",
  "changeLanguage": "ภาษา",
  "termsAndConditions": "ข้อกำหนดและเงื่อนไข",
  "messagePlaceholder": "พิมพ์ข้อความของคุณที่นี่ ...",
  "messagePlaceholderDisabled": "ปิดใช้งานการพิมพ์ ... ",
  "feedbackTitle": "ให้คะแนน",
  "feedbackPlaceholder": "คำแนะนำเพิ่มเติม",
  "feedbackSend": "ส่ง",
  "feedbackClose": "ปิด",
  "sessionExpired": "ช่วงเวลาสนทนาของคุณสิ้นสุดลงแล้ว",
  "startNewSession": "เริ่มการสนทนาใหม่",
  "apiError": "เกิดข้อผิดพลาดบางอย่าง เรากำลังแก้ไขปัญหานี้โดยเร็วที่สุด",
  "apiErrorOffline": "คุณไม่ได้เชื่อมต่อกับอินเทอร์เน็ต",
  "tryAgain": "ลองอีกครั้ง",
  "startOver": "เริ่มใหม่",
  "chatEnded": "การสนทนาสิ้นสุดลง",
  "chatEndedThankYou": "ขอบคุณที่ใช้บริการ",
  "closeChat": "ปิด",
  "startNewChat": "เริ่มการสนทนาอีกครั้ง",
  "humanTakeoverStarted": "ระบบกำลังทำการเชื่อมต่อไปยังเจ้าหน้าที่บริการลูกค้า",
  "humanTakeoverQueued": "กำลังเชื่อมต่อกับเจ้าหน้าที่บริการลูกค้า",
  "humanTakeoverAnAgent": "เจ้าหน้าที่บริการลูกค้า",
  "humanTakeoverAgentEntered": "เริ่มต้นการสนทนา",
  "humanTakeoverAgentLogout": "ออกจากการสนทนา",
  "humanTakeoverTransfer": "คุณกำลังเชื่อมต่อไปยังเจ้าหน้าที่บริการลูกค้าอีกครั้ง",
  "humanTakeoverEnded": "คุณกำลังสนทนากับผู้ช่วยอัตโนมัติของคุณ",
  "version": "รุ่น",
  "formIntroText": "โปรดกรอกแบบฟอร์มเพื่อเริ่มบทสนทนากับเรา",
  "formFirstName": "ชื่อ",
  "formLastName": "นามสกุล",
  "formName": "ชื่อ",
  "formEmail": "อีเมล",
  "formWrongEmail": "โปรดระบุอีเมลที่ถูกต้อง",
  "formPhone": "โทรศัพท์",
  "formShipmentId": "หมายเลขพัสดุ",
  "formQuestion": "คำถามของคุณ",
  "formAccountNumber": "เลขที่บัญชี (สำหรับลูกค้าธุรกิจ)",
  "formAddress": "ที่อยู่",
  "formPostcode": "รหัสไปรษณีย์",
  "formCity": "เมือง",
  "formCountry": "ประเทศ",
  "formSubmitButton": "เริ่มสนทนา",
  "formEmptyFieldError": "ไม่อนุญาตให้เว้นว่าง",
  "formPhoneNumberValidationError": "หมายเลขโทรศัพท์ไม่ถูกต้อง",
  "formInputIsBiggerThan50": "จำนวนอักษรไม่เกิน 50 ตัว",
  "formInputIsBiggerThan100": "จำนวนอักษรไม่เกิน 100 ตัว",
  "formInputIsBiggerThan2000": "จำนวนอักษรไม่เกิน 2000 ตัว",
  "widgetEventOnline": "ข้อความ DA: ผู้ใช้กลับมาออนไลน์",
  "widgetEventHidden": "ข้อความ DA: หน้าต่างถูกซ่อน",
  "widgetEventVisible": "ข้อความ DA: หน้าต่างมองเห็นได้",
  "widgetEventVisibleMinimized": "ข้อความ DA: หน้าต่างมองเห็นได้ แต่ถูกย่อ",
  "widgetEventMinimized": "ข้อความ DA: หน้าต่างถูกย่อ",
  "widgetEventMaximized": "ข้อความ DA: หน้าต่างถูกขยาย",
  "widgetEventSessionExpired": "ข้อความ DA: ช่วงเวลาสนทนาสิ้นสุดลงแล้ว",
  "widgetEventHangupHuman": "ข้อความ DA: ผู้ใช้สิ้นสุดเซสชันการครอบครองของมนุษย์",
  "widgetEventUserTyping": "ข้อความ DA: ผู้ใช้กำลังพิมพ์",
  "fileTooLarge": "ไฟล์ที่แนบใหญ่เกินไป (สูงสุด30 MB)",
  "tooManyDiles": "ไฟล์ที่แนบมากเกินไป (สูงสุด10ไฟล์)",
  "fileInvalidType": "ไฟล์ที่แนบไม่ถูกต้อง (เฉพาะ pdf หรือ image)",
  "attachmentsDropHere": "วางที่นี่เพื่อUpload",
  "attachmentsBrowse": "เรียกดูไฟล์",
  "attachmentsExtenstionQuantity": "pdf หรือ image (สูงสุด 10 ไฟล์)",
  "attachmentsSize": "สูงสุด 30 MB",
  "attachmentsFailedUploading": "การUploadล้มเหลว",
  "attachmentsUploading": "กำลังUpload ...",
  "minimizeExpandText": "สนทนาสดกับเราตอนนี้!",
  "popupWidgetNotificationMessage": "คุณได้รับข้อความใหม่!",
  "tabWidgetNotificationMessage": "ข้อความใหม่!",
  "datepickerSendButton": "ส่ง"
}
